(function () {
  var STORAGE_KEY = "pyranext:selectedDeliveryWindow";

  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatTemplate(template, values) {
    return Object.keys(values).reduce(function (output, key) {
      return output.split("{{ " + key + " }}").join(values[key]);
    }, template || "");
  }

  function capacityText(capacity, strings) {
    if (capacity <= 0) return strings.capacityZero;
    if (capacity === 1) return formatTemplate(strings.capacityOne, { count: capacity });
    return formatTemplate(strings.capacityOther, { count: capacity });
  }

  function statusFromCapacity(capacity) {
    if (capacity <= 0) return "full";
    if (capacity <= 3) return "filling";
    return "open";
  }

  /**
   * Delivery window app seam:
   * The storefront consumes exactly this contract:
   * [{ id: "window-2", time: "14:00 - 16:00", capacity: 11, status: "open" }]
   * Replace this mock adapter with a delivery-slot app, metafield schedule,
   * or custom service that returns the same shape. Markup and CSS do not need
   * to change as long as id, time, capacity, and status remain stable.
   */
  function getMockDeliveryWindows(config) {
    return (config.windows || []).map(function (windowItem) {
      var capacity = Number(windowItem.capacity || 0);
      return {
        id: windowItem.id,
        time: windowItem.time,
        capacity: capacity,
        status: statusFromCapacity(capacity)
      };
    });
  }

  function saveSelectedWindow(windowItem) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(windowItem));
    } catch (error) {
      return;
    }
  }

  function readSelectedWindow() {
    try {
      var saved = window.sessionStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      return null;
    }
  }

  function setText(selector, text) {
    document.querySelectorAll(selector).forEach(function (node) {
      node.textContent = text;
    });
  }

  function updateSharedWindowLabels(windowItem, strings) {
    var selected = windowItem && windowItem.time;
    setText("[data-header-window]", selected ? formatTemplate(strings.headerSelected, { time: windowItem.time }) : strings.headerNone);
    setText("[data-basket-window]", selected ? windowItem.time : strings.noWindow);
    setText("[data-cart-window]", selected ? windowItem.time : strings.noWindow);
  }

  function renderRow(row, windowItem, strings, selectedId) {
    var status = windowItem.status;
    var isSelected = selectedId === windowItem.id && status !== "full";
    var displayStatus = isSelected ? strings.selected : strings[status];
    var actionText = status === "full" ? strings.notOffered : strings.select;
    row.classList.remove("is-open", "is-filling", "is-full", "is-selected");
    row.classList.add("is-" + status);
    if (isSelected) row.classList.add("is-selected");
    row.disabled = status === "full";
    row.dataset.windowStatus = status;
    row.dataset.windowCapacity = String(windowItem.capacity);
    row.querySelector("[data-flap='time']").textContent = windowItem.time;
    row.querySelector("[data-flap='status']").textContent = displayStatus;
    row.querySelector("[data-flap='capacity']").textContent = capacityText(windowItem.capacity, strings);
    row.querySelector(".row-action").textContent = actionText;
    row.setAttribute("aria-label", formatTemplate(strings.aria, {
      time: windowItem.time,
      status: displayStatus,
      capacity: capacityText(windowItem.capacity, strings)
    }));
  }

  function flipRow(row) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    row.classList.remove("is-flipping");
    window.requestAnimationFrame(function () {
      row.classList.add("is-flipping");
      window.setTimeout(function () {
        row.classList.remove("is-flipping");
      }, 560);
    });
  }

  function initDeliveryBoard(section) {
    var config = readJson(section.querySelector("[data-window-config]"));
    if (!config) return;
    var strings = config.strings;
    var windows = getMockDeliveryWindows(config);
    var saved = readSelectedWindow();
    var selectedId = saved && saved.id;
    var selectedTarget = section.querySelector("[data-board-selected]");
    var byId = {};

    windows.forEach(function (windowItem) {
      byId[windowItem.id] = windowItem;
    });

    if (!byId[selectedId] || byId[selectedId].status === "full") {
      selectedId = null;
    }

    section.querySelectorAll("[data-window-row]").forEach(function (row) {
      var windowItem = byId[row.dataset.windowId];
      if (!windowItem) return;
      renderRow(row, windowItem, strings, selectedId);
      row.addEventListener("click", function () {
        if (windowItem.status === "full") return;
        selectedId = windowItem.id;
        saveSelectedWindow(windowItem);
        section.querySelectorAll("[data-window-row]").forEach(function (otherRow) {
          var other = byId[otherRow.dataset.windowId];
          renderRow(otherRow, other, strings, selectedId);
        });
        flipRow(row);
        if (selectedTarget) selectedTarget.textContent = windowItem.time;
        updateSharedWindowLabels(windowItem, strings);
      });
    });

    if (selectedId) {
      if (selectedTarget) selectedTarget.textContent = byId[selectedId].time;
      updateSharedWindowLabels(byId[selectedId], strings);
    } else {
      updateSharedWindowLabels(null, strings);
    }
  }

  function initHeaderOnlyLabels() {
    var config = readJson(document.querySelector("[data-header-window-config]"));
    if (!config) return;
    var saved = readSelectedWindow();
    updateSharedWindowLabels(saved, {
      headerSelected: config.selected,
      headerNone: config.empty,
      noWindow: config.statusEmpty
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-delivery-board]").forEach(initDeliveryBoard);
    initHeaderOnlyLabels();
  });
})();
function cleanGeneratedPolicyCopy(replacements) {
  if (!window.location.pathname.includes('/policies/')) return;

  const main = document.querySelector('main');
  if (!main) return;

  const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((node) => {
    let value = node.nodeValue;
    replacements.forEach(([from, to]) => { value = value.split(from).join(to); });
    node.nodeValue = value;
  });

  main.querySelectorAll('a[href]').forEach((link) => {
    let href = link.getAttribute('href');
    replacements.forEach(([from, to]) => { href = href.split(from).join(to); });
    link.setAttribute('href', href);
  });
}

cleanGeneratedPolicyCopy([
  ['supermarket', 'Departures Market'],
  ['orders@example.com', 'info@pyranext.com'],
  ['warherome@gmail.com', 'info@pyranext.com'],
  ['+20 100 000 0000', 'info@pyranext.com']
]);
